"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SettingsMenuItem_1 = __importDefault(require("./styles/SettingsMenuItem"));
var DesignSystemNavBar = function (_a) {
    var onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsx)(SettingsMenuItem_1.default, { onCloseDropdown: onClick, to: "/design-system", label: "Design System" }));
};
exports.default = DesignSystemNavBar;
